import { BasketDeliveryAddress, ContextualPricing, Discount, Fee, HandoffMethods, Tax } from '.';

export class UserRecentOrders {
    orders: Array<RecentOrder>;

    public static Make(obj: any): UserRecentOrders {
        const recentOrders = new UserRecentOrders();
        Object.assign(recentOrders, obj);
        return recentOrders;
    }
}

export class RecentOrder {
    id: string;
    oloid: string;
    vendorid: number;
    status: string;
    subtotal: number;
    salestax: number;
    taxes: Array<Tax>;
    fees: Array<Fee>;
    totalfees: number;
    total: number;
    timemode: string;
    tip: number;
    mode?: string;
    billingaccountid?: string;
    billingaccountids?: Array<string>;
    contextualpricing: ContextualPricing;
    deliveryaddress: BasketDeliveryAddress;
    customfields: Array<CustomField>;
    iseditable: boolean;
    discount: number;
    discounts: Array<Discount>;
    orderref: string;
    timeplaced: string;
    readytime: string;
    vendorname: string;
    vendorextref: string;
    deliverymode: HandoffMethods;
    customerhandoffcharge?: number;
    arrivalstatus: string;
    hasolopass?: boolean;
    products: Array<RecentOrderProduct>;
    unavailableproducts: Array<RecentOrderProduct>;
    posreferenceresponse?: string;
}

class CustomField {
    id: number;
    label: string;
    value: string;
    isrequired: boolean;
    validationregex: string;
    scope: string;
}

export class RecentOrderProduct {
    id: string;
    chainproductid: string;
    name: string;
    quantity: number;
    totalcost: number;
    specialinstructions?: string;
    custompassthroughdata?: string;
    choices: Array<Choice>;
}

class Choice {
    id: string;
    chainchoiceid: string;
    name: string;
    quantity: number;
}
